"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyTableToolBar = void 0;

const Clear_1 = __importDefault(require("@mui/icons-material/Clear"));

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const SskyIconButton_1 = __importDefault(require("../SskyIconButton"));

const StyledToolbar = (0, material_1.styled)(material_1.Toolbar, {
  shouldForwardProp: prop => prop !== "numSelected"
})(({
  theme,
  numSelected
}) => Object.assign({
  minHeight: "unset",
  height: 54,
  paddingRight: theme.spacing(1),
  paddingLeft: 12,
  borderBottom: "1px solid rgba(224, 224, 224, 1)"
}, numSelected > 0 && {
  color: "#fff",
  backgroundColor: theme.palette.primary.main
}));
const StyledTypography = (0, material_1.styled)(material_1.Typography)({
  [`&.${material_1.typographyClasses.root}`]: {
    flex: "none",
    marginRight: 20
  }
});
const StyledDivider = (0, material_1.styled)("div")({
  backgroundColor: "#fff",
  marginRight: 15,
  height: 40,
  width: 1
});
const StyledSpacer = (0, material_1.styled)("div")({
  flex: "1 1 auto"
});
const StyledRightChildrenContainer = (0, material_1.styled)("div")({
  paddingRight: 30
});

const SskyTableToolBar = props => {
  var _a, _b, _c, _d, _e, _f;

  return react_1.default.createElement(StyledToolbar, {
    className: (0, classnames_1.default)(props.className, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.root, {
      [(_b = props.classes) === null || _b === void 0 ? void 0 : _b.highlight]: props.numSelected > 0
    }),
    numSelected: props.numSelected
  }, props.numSelected > 0 && react_1.default.createElement(StyledTypography, {
    classes: {
      root: (_c = props.classes) === null || _c === void 0 ? void 0 : _c.typography
    },
    variant: "subtitle1",
    align: "left"
  }, props.numSelected, " selected"), props.numSelected <= 0 && props.title && react_1.default.createElement(StyledTypography, {
    sx: {
      color: "text.primary"
    },
    variant: "subtitle1",
    align: "left"
  }, props.title), props.numSelected <= 0 && props.titleElement && react_1.default.createElement("div", null, props.titleElement), props.numSelected > 0 && react_1.default.createElement(StyledDivider, {
    className: (_d = props.classes) === null || _d === void 0 ? void 0 : _d.divider
  }), props.numSelected > 0 && props.selectedChildren, props.numSelected <= 0 && props.unSelectedChildren, react_1.default.createElement(StyledSpacer, {
    className: (_e = props.classes) === null || _e === void 0 ? void 0 : _e.spacer
  }), react_1.default.createElement("div", null, props.numSelected > 0 && react_1.default.createElement(SskyIconButton_1.default, {
    className: "clear-table-selection",
    tooltip: "Clear Selection",
    icon: react_1.default.createElement(Clear_1.default, null),
    onClick: props.onClearSelect,
    dataTestId: props.dataTestId
  }), props.numSelected <= 0 && react_1.default.createElement(StyledRightChildrenContainer, {
    className: (_f = props.classes) === null || _f === void 0 ? void 0 : _f.rightChildren
  }, props.rightUnSelectedChildren)));
};

exports.SskyTableToolBar = SskyTableToolBar;
exports.default = react_1.default.memo(SskyTableToolBar);